interface CheckboxListProps {
  items: string[];
  selectedItems: string[];
  onChange: (selectedItems: string[]) => void;
}

const CheckboxList = ({
  items,
  selectedItems,
  onChange,
}: CheckboxListProps) => {
  const handleItemChange = (item: string) => {
    const newSelectedItems = selectedItems.includes(item)
      ? selectedItems.filter((i) => i !== item)
      : [...selectedItems, item];
    onChange(newSelectedItems);
  };

  return (
    <div className="flex flex-col gap-0.5">
      {items.map((item) => {
        const id = `item-${item}`;
        return (
          <div
            key={item}
            className="inline-flex items-center gap-1.5 px-1 py-0.5 rounded-lg transition-colors hover:bg-gray-50 cursor-pointer"
          >
            <label
              className="relative flex items-center p-2 rounded-full cursor-pointer"
              htmlFor={id}
            >
              <input
                type="checkbox"
                className="before:content[''] peer relative h-[18px] w-[18px] cursor-pointer appearance-none rounded border border-gray-300 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-primary checked:bg-primary checked:before:bg-primary hover:border-gray-400 hover:before:opacity-10"
                id={id}
                onChange={() => handleItemChange(item)}
                checked={selectedItems.includes(item)}
              />
              <span className="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="1"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            </label>
            <label
              className="text-sm font-medium text-gray-600 truncate cursor-pointer select-none hover:text-gray-900 transition-colors"
              htmlFor={id}
            >
              {item}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default CheckboxList;
